import { useCallback } from "react";
import { usePreload } from "../DataContext/PreloadContext";
import { uploadMedia } from "../../services/mediaService";
import { UploadType } from "../../types/enum";

export const useImageUpload = ({ current, setCurrent, onSave, imageField, resourceField }) => {
  const { fileUploadDialog } = usePreload();

  const handleImageUpload = useCallback(
    async ({ uploadType, imageFile, imageLink }) => {
      try {
        fileUploadDialog.setLoading(true);

        let updated = {
          ...current,
          [resourceField]: "",
          [imageField]: imageLink ?? current[imageField] ?? "",
        };

        if (uploadType === UploadType.FILE) {
          const res = await uploadMedia(imageFile);

          if (res?.resourceId) {
            updated[resourceField] = res.resourceId;
            updated[imageField] = res.resourceUrl;
          }
        }

        setCurrent(updated);
        await onSave(updated);
      } catch (e) {
        console.error(e);
      } finally {
        fileUploadDialog.setLoading(false);
        fileUploadDialog.hide();
      }
    },
    [current, setCurrent, onSave]
  );

  const openUploader = useCallback(() => {
    fileUploadDialog.show({
      title: "Upload Image",
      imageLink: current[imageField],
      handleImageUpload,
    });
  }, [current, handleImageUpload]);

  return {
    openUploader,
  };
};
